<div class="header-container" [ngClass]="{ 'small-header': isSmall }">
    <div class="certificates-wrapper__item-img">
        <cm-step-details-header-icon class="step-icon" [data]="data"></cm-step-details-header-icon>
    </div>
    <div class="name-container">
        <div class="certificates-wrapper__item-data__name">
            <h5 class="prof-header prof-header--level-3">{{ data.name }}</h5>
            <span
                class="draft-label bold"
                *ngIf="
                    data.step_type_id === STEP_TYPES.ONBOARDING &&
                    !isStepSubmitted(data.status_id) &&
                    data.content.isDraft
                "
                >draft</span
            >
        </div>
        <div class="name-container-status-block">
            <div class="name-container-row">
                <cm-icon name="completion" class="name-container-row-image"></cm-icon>
                <span
                    class="name-container-row-text"
                    [ngClass]="{ 'passed-date': data.status_id === constants.STEP_TYPE_STATUSES.PASSED_DUE_DATE }"
                >
                    {{ statusName }}
                </span>
            </div>
            <div class="name-container-row name-container-row__middle">
                <cm-icon name="step-type" class="name-container-row-image"></cm-icon>
                <span
                    class="name-container-row-text"
                    [ngClass]="{ 'passed-date': data.status_id === constants.STEP_TYPE_STATUSES.PASSED_DUE_DATE }"
                >
                    {{ data.step_type_name }}
                    <ng-container *ngIf="data.step_type_id === STEP_TYPES.LOG">
                        ({{ data.content.role }})
                    </ng-container>
                </span>
            </div>
            <div class="name-container-row">
                <cm-icon name="calendar" class="name-container-row-image"></cm-icon>
                <span
                    class="name-container-row-text"
                    [ngClass]="{ 'passed-date': data.status_id === constants.STEP_TYPE_STATUSES.PASSED_DUE_DATE }"
                >
                    {{ data.end_date | dateFormat }}
                    <span
                        *ngIf="
                            data.status_id === constants.STEP_TYPE_STATUSES.INCOMPLETE &&
                            (data.status_color === statuses.ORANGE || data.status_color === statuses.RED)
                        "
                    >
                        {{ data.end_date | daysLeft }}</span
                    >
                </span>
            </div>
        </div>
        <ng-container [ngTemplateOutlet]="template"></ng-container>
    </div>
</div>
